// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"FailedTable_pageTitle__1EC7l","tableSection":"FailedTable_tableSection__3WuEk","action":"FailedTable_action__2SY7c"};